// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__994lI","link":"style_link__5wtyu","ative-link":"style_ative-link__a-3y4"};